import Enllac from 'components/3cat/Enllac';
import { useRouter } from 'next/router';
import Dropdown from './../Dropdown';
import styles from './llistatVideos.module.scss';

import __isEmpty from 'lodash/isEmpty';

export default function Component(props) {
    const {
        routerQuery,
        temporada,
        nomPrograma,
        reglesTemporada,
        isTemporades,
        seccions,
        blocTitol,
        linkTipus,
        linkSlugRelacio,
        routeTypeTemporada,
        slug2
    } = props;

    let estilDropdown = blocTitol && linkTipus ? 'combo' : null,
        linkSlug2 = !__isEmpty(slug2) ? slug2 : 'capitols';

    const _getSeccions = () => {
        const _getAgrupadora = (agrupadores) => {
            if (__isEmpty(agrupadores)) return 'PUAG_NODATA'; // hardcoded fallback
            const agrupadoraMain = agrupadores.filter((agrupadora) => agrupadora.main);
            return !__isEmpty(agrupadoraMain) && agrupadoraMain[0].id ? agrupadoraMain[0].id : 'PUAG_NOMAIN'; // hardcoded fallback
        };
        // Sempre llistem la secció 'Tots'
        let llistatSeccions = [
            {
                id: '',
                titol: 'Tots',
                type: 'itemProgramaClips'
            }
        ];
        if (!__isEmpty(seccions)) {
            // Llistem totes les seccions del programa
            // amb el seu 'id' d'agrupadora (fallbacks en cas d'error/omissió a l'API)
            seccions.forEach((seccio) => {
                llistatSeccions.push({
                    id: _getAgrupadora(seccio.puagrupa),
                    titol: seccio.desc,
                    type: 'itemProgramaClipsAgrupacio'
                });
            });
        }
        return llistatSeccions;
    };

    const _getListTemporades = () => {
        let temporades = [],
            routeType = routeTypeTemporada ? routeTypeTemporada : 'web_3cat_programa_temporada_item';
        for (let i = 1; i <= temporada?.substring(7); i++) {
            temporades.push({
                id: 'PUTEMP_' + i,
                titol: 'Temporada ' + i,
                temporada: i,
                type: routeType
            });
        }
        return reglesTemporada === 'ARXIU' ? temporades : temporades.reverse();
    };
    const items = isTemporades ? _getListTemporades() : _getSeccions();
    const active = isTemporades
        ? routerQuery.temporadaid
            ? 'PUTEMP_' + routerQuery.temporadaid
            : items?.[0]?.id
        : routerQuery.agrupacio
        ? routerQuery.agrupacio
        : items?.[0]?.id;

    const router = useRouter();

    const updateDropdownTemporades = (item) => {
        router.push('/3cat/' + nomPrograma + '/' + linkSlug2 + '/temporada/' + item.temporada);
    };

    let textBoto = active?.substring(7);
    textBoto = active?.includes('PUTEMP_') ? 'Temporada ' + textBoto : 'Selector temporades';

    return (
        <div className={styles.itemllistat}>
            <div className={styles.titolCombo}>
                {linkTipus && blocTitol && (
                    <Enllac
                        slug={nomPrograma}
                        slug2='capitols'
                        type={linkTipus}
                        className={styles.titol}
                        titol={blocTitol}
                        slugRelacio={linkSlugRelacio}
                    ></Enllac>
                )}
                {items.length !== 0 && (
                    <Dropdown
                        textSelector={textBoto}
                        updateDropdown={updateDropdownTemporades}
                        className={estilDropdown}
                        items={items}
                    />
                )}
            </div>
        </div>
    );
}
